import React, { useEffect, useState } from "react";
import { Container, Box, Checkbox, Button, Divider } from "@mui/material";
import "./SuccessScreen.css";
import logo from "../assets/logo.png";
import emoji from "../assets/emoji.png";
import googleLogo from "../assets/google.ico";
import { getSessionStatus } from "../api/stripe";
import { useNavigate, useParams } from "react-router-dom";
import { getTipById, updateTip } from "../api/tip";
import { getBusinessByQrId } from "../api/business";
import { KTCookie } from "../utils/cookie";
import {
  deleteTiper,
  getTiperByEmail,
  getTiperById,
  postTiper,
  updateTiper,
} from "../api/tiper";
import CookieConsent from "react-cookie-consent";
import { getTextById } from "../api/text";

const SuccessScreen = () => {
  const [status, setStatus] = useState(null);
  const [paymentStatus, setPaymentStatus] = useState(null);
  const [tip, setTip] = useState(null);
  const [landOut, setLandOut] = useState(new Date());
  const [customerEmail, setCustomerEmail] = useState("");
  const [type, setType] = useState("");
  const [wallet, setWallet] = useState("");
  const navigate = useNavigate();
  const businessId = useParams().id;
  const [business, setBusiness] = useState({});
  const [textCookeis, setTextCoookies] = useState("");
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const sessionId = urlParams.get("session_id");
  const tipId = useParams().idtip;

  useEffect(() => {
    const fetchData = async () => {
      await getTextById("679c9c23474dd68f9a1080d9").then((res) => {
        if (res.status === 200) {
          setTextCoookies(res.data.content["es"]);
        }
      });
      await getBusinessByQrId(businessId).then((res) => setBusiness(res.data));
      await getSessionStatus(sessionId).then(async (res) => {
        setWallet(res.data.payment_wallet);
        setType(res.data.type);
        setStatus(res.data.status);
        setPaymentStatus(res.data.payment_status);
        setCustomerEmail(res.data.customer_email);
        await getTipById(tipId).then((res2) => {
          setTip(res2.data);
          if (!res2.data.landOut) {
            handleUpdateTip(
              res2.data,
              false,
              null,
              res.data.payment_wallet,
              res.data.payment_type,
              res.data.payment_status,
              res.data.customer_email
            );
          }
        });
      });
    };

    fetchData();
  }, []);
  useEffect(() => {}, [tipId, businessId]);

  const handleUpdateTip = async (
    tip,
    clickGoogle,
    fechaClickGoogle,
    wallet,
    type,
    status,
    customerEmail
  ) => {
    if (!tip.landOut) {
      tip.landOut = landOut;
      tip.metodoPago = wallet !== undefined ? wallet : type;
      tip.estadoPago = status;
      let newTiper;
      await getTiperByEmail({ email: customerEmail })
        .then(async (res) => {
          if (res.status === 200) {
            if (tip.tiper !== res.data._id) {
              await deleteTiper(tip.tiper).catch((error) => console.log(error));
              const options = {
                expires: new Date("9999-12-31T23:59:59.999Z"),
                path: "/",
              };
              const cookie = KTCookie.getCookie("tipifyCookie");
              if (cookie) {
                KTCookie.deleteCookie("tipifyCookie");
                KTCookie.setCookie("tipifyCookie", res.data._id, options);
              } else {
                KTCookie.setCookie("tipifyCookie", res.data._id, options);
              }
            }
            newTiper = res.data._id;
          }
        })
        .catch(async (error) => {
          if (error.code === "ERR_BAD_REQUEST") {
            await getTiperById(tip.tiper)
              .then(async (res) => {
                const newTiper = res.data;
                newTiper.email = customerEmail;
                await updateTiper(newTiper._id, newTiper).catch((error) => {
                  console.log(error);
                });
              })
              .catch(async (error) => {
                console.log(error);
                if (error.code === "ERR_BAD_REQUEST") {
                  await postTiper({ email: customerEmail })
                    .then((res) => {
                      const options = {
                        expires: new Date("9999-12-31T23:59:59.999Z"),
                        path: "/",
                      };
                      KTCookie.deleteCookie("tipifyCookie");
                      KTCookie.setCookie("tipifyCookie", res.data.id, options);
                      newTiper = res.data.id;
                    })
                    .catch((error) => console.log(error));
                }
              });
          } else {
            console.log(error);
          }
        });
      if (newTiper) tip.tiper = newTiper;
    } else if (!tip.clickGoogle) {
      tip.clickGoogle = clickGoogle;
      tip.fechaClickGoogle = fechaClickGoogle;
    }
    setTip(tip);
    await updateTip(tipId, tip).catch((error) => {
      console.log(error);
    });
  };

  const handleGoogle = () => {
    handleUpdateTip(tip, true, new Date(), wallet, type, paymentStatus);
    if (business.googleURL) {
      window.open(
        `https://search.google.com/local/writereview?placeid=${business.googleURL}`,
        "_blank"
      );
    } else {
      window.open("https://www.google.com", "_blank");
    }
  };

  if (status === "open") {
    navigate(`/${businessId}/stripe/${tipId}`);
  }

  if (status === "complete") {
    return (
      <Container className="container-fluid success-container">
        {/* Logo */}
        <div className="logo-container mt-3">
          <img src={logo} alt="Tipify Logo" className="logo2" />
        </div>
        {/* Mensaje principal */}
        <h4 className="main-text text-secondary">¡Propina en el Bote!</h4>

        {/* Emoji de celebración */}
        <Box className="emoji-container">
          <img src={emoji} alt="Celebration Emoji" className="emoji" />
        </Box>

        {/* Mensaje de agradecimiento */}
        <p className="thanks-text text-secondary mb-5">
          Gracias por dejar la propina. <br />
          Vuelve pronto.
        </p>

        {/* Checkbox para crear cuenta */}
        {/* <Box className="checkbox-container">
        <Checkbox />
        <p className="checkbox-text">
          Usa mis datos para <span className="highlight">crear una cuenta</span>{" "}
          en Tipify Technologies. <span className="link">Condiciones</span>
        </p>
      </Box> */}

        {/* Botón de compartir en Google */}
        <div className="d-flex flex-column text-center">
          <div className="mt-5">
            <Divider
              sx={{
                borderBottomWidth: 3,
                borderColor: "#66bc5f",
                width: "75%",
                opacity: 1,
                borderRadius: "10px",
                margin: "0 auto", // Centrar horizontalmente
                display: "block", // Asegurar que ocupe todo el ancho definido
              }}
            />
          </div>
          <span className="ask-text text-secondary">
            ¿Nos ayudas un poco más, compartiendo tu experiencia en Google?
          </span>
          <div className="mt-3">
            <Button
              style={{
                backgroundColor: "#f2f2f2",
                fontSize: "20px",
                color: "#888583",
                borderRadius: "30px",
                padding: "10px",
                width: "220px",
                height: "50px",
                textTransform: "none",
                border: "1px solid #888583",
                boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)", // Added box shadow
              }}
              onClick={() => {
                handleGoogle();
              }}
            >
              <div className="container">
                <img src={googleLogo} alt="Google" className="google-logo" />
                <span>¡Vamos!</span>
              </div>
            </Button>
          </div>
        </div>
        <CookieConsent
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 9999,
            textAlign: "left",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            maxHeight: "35%",
          }}
          buttonStyle={{
            backgroundColor: "#66bc5f",
            color: "#fff",
            fontSize: "16px",
            padding: "15px",
            width: "100%",
          }}
          cookieName="myAwesomeCookieName3"
          expires={999}
          buttonText="Aceptar"
          overlay
        >
          <div dangerouslySetInnerHTML={{ __html: textCookeis }} />
          <a
            href="/politica-cookies"
            style={{ color: "#fff", textDecoration: "underline" }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Leer más
          </a>
        </CookieConsent>
      </Container>
    );
  }
  return null;
};

export default SuccessScreen;
